import { NodeModel } from "../_model/NodeModel";
import { DecorationAreaJoker } from "./decorationAreaJoker"
import { Types } from "../../utils/nodeTypes"

class AreaJoker extends NodeModel {
  constructor(areaJokerName) {
    super("AreaJoker");
    
    this.areaName = "?"
    this.type = new Types().AreaJoker;
    this.x = 0;
    this.y = 0;
    this.fontSize = 25;  
    this.height = 50;
    this.width = 150;
   
    this.yText = () => this.y + (this.height / 1.6) + (this.fontSize / 5);
    this.xText = () => this.x + 5;
    this.wasSet = false

    this.decorate = async function(callback, callback2) {
      this.decorator = new DecorationAreaJoker();
      await this.decorator.init(this, callback, callback2)
    }

    this.update = (nodeEdited) => {
      this.areaName = nodeEdited.areaName
      this.fontSize = nodeEdited.fontSize
      this.expressionVisible = nodeEdited.expressionVisible;
      this.wasSet = true;
      let newWidth =  this.areaName.length >= 5 ? this.areaName.length * 8 * (this.fontSize * 0.1) : 
                      this.areaName.length * 7 * (this.fontSize * 0.05);

      let newHeight = this.areaName.length >= 5 ? this.areaName.length * 5 * (this.fontSize * 0.06) : 
                      this.areaName.length * 1 * (this.fontSize / 0.5);
     

      this.width = newWidth
      this.height = newHeight
      
      this.decorator.setAdjustArea()

      console.log(nodeEdited.openArea)
      if(nodeEdited.openArea){
        setTimeout(() => {
          this.decorator.openArea(this.areaName)
        }, 500)
      }
    }

    this.clone = () => {
      let cloned = new AreaJoker(areaJokerName)
      cloned.id = this.id
      cloned.idName = this.idName
      cloned.type = this.type
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.x = this.x
      cloned.y = this.y
      cloned.readOnly = this.readOnly
      cloned.areaName = this.areaName
      cloned.expressionVisible = this.expressionVisible
      cloned.wasSet = this.wasSet
      cloned.fontSize = this.fontSize

      return cloned
    }

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node)
      this.areaName = node.areaName
      this.wasSet = node.wasSet
      this.fontSize = node.fontSize
    }
  }
}


export { AreaJoker };